import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import type { Meeting } from 'features/meetings/types';
import { timeNotationSelector, timezoneSelector } from 'selectors/current_user';
import { summarizeInterval } from 'shared/utils';
const timeRangeContainerCss = "t1of2xzi";
const timeDisplayCancelledCss = "tmlwppc";
const timeDisplayCss = "tl60baj";
interface MeetingTimeProps {
  className?: string;
  event: Meeting;
}

/**
 * Renders the formatted time range for a meeting card.
 *
 * Displays the meeting's start and end times in the user's timezone and
 * preferred time notation. Applies a strikethrough style when the meeting
 * is cancelled.
 *
 * Implemented with `forwardRef` so the root element can be targeted by callers.
 * The meetings page onboarding spotlight tour (`MeetingsPageOnboardingTour`) relies
 * on this ref for the first-upcoming-meeting step anchor.
 *
 * @param className - Optional additional CSS class for the container
 * @param event - The meeting whose time range is displayed
 */
export const MeetingTime = forwardRef<HTMLDivElement, MeetingTimeProps>(({
  className,
  event
}, ref) => {
  const timezone = useSelector(timezoneSelector);
  const timeNotation = useSelector(timeNotationSelector);
  const {
    cancelled,
    startTime,
    endTime
  } = event;
  const eventStartTime = moment(startTime).tz(timezone);
  const eventEndTime = moment(endTime).tz(timezone);
  const timeLabel = summarizeInterval({
    from: eventStartTime,
    to: eventEndTime
  }, timeNotation, false);
  return <div className={classNames(timeRangeContainerCss, className)} ref={ref}>
      <div className={classNames(timeDisplayCss, {
      [timeDisplayCancelledCss]: cancelled
    })}>
        <BodyText size="medium">
          {timeLabel}
        </BodyText>
      </div>
    </div>;
});
MeetingTime.displayName = 'MeetingTime';

require("./MeetingTime.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingTime.tsx");